export { default } from './ChevronLeftThin'
